import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './inicident-abteilungsleitstelle.reducer';
import {GroupVerantwortung} from './inicident-abteilungsleitstelle.model.ui';
import {IncidentManagementBenutzerZugriff, IncidentDetail, IncidentKopf, IncidentsAnzeigeMandantOptions, Rolle} from '../../../clients/incidents';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {getIncidentsMandantOptions} from '@orga-app/mandant/reducer';
import {getZugriffIncidents} from '../../navi/navi.reducer';


export const getModuleState = createFeatureSelector<ModuleState>('IncidentAbteilungsleitstellePage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

export const getSelectedVeranstaltungsIds = createSelector(getPageState, (state: PageState) => {
    if (state.localData === undefined || state.localData === null) {
        return [];
    }
    return state.localData.selectedVeranstaltungsIds;
});

export const getFunktionsbereichsId = createSelector(getPageState, (state: PageState) => state.funktionsbereichId);

export const getAbgeschlosseneAnzeigen = createSelector(getPageState, (state: PageState) => state.abgeschlosseneAnzeigen);

export const getEingang = createSelector(getPageState, getAbgeschlosseneAnzeigen, (state: PageState, abgeschlosseneAnzeigen: boolean) => {
    const retListe: Array<ListInputItem> = [];
    if (state.eingang === null) {
        return [];
    }

    state.eingang.map((item: IncidentKopf) => {
        if (abgeschlosseneAnzeigen || !item.ist_abgeschlossen) {
            retListe.push(<ListInputItem>{
                groupId: 'Aktuelle Veranstaltungen',
                groupTitle: 'Aktuelle Veranstaltungen',
                itemId: item.incident_id,
                itemTitle: item.titel,
                item: item
            });
        }
    });

    return retListe;
});

export const getEingangLaden = createSelector(getPageState, (state: PageState) => state.eingangLaden);

export const getListe = createSelector(getPageState, getAbgeschlosseneAnzeigen, (state: PageState, abgeschlosseneAnzeigen: boolean) => {
    const retListe: Array<GroupVerantwortung> = [];

    if (state.liste === undefined || state.liste === null || state.liste.rollen === undefined || state.liste.rollen === null) {
        return retListe;
    }

    state.liste.rollen.forEach(rolle => {
        if (abgeschlosseneAnzeigen) {
            retListe.push({
                rolle: rolle,
                items: state.liste.items.filter(x => x.delegation_rolle_id === rolle.rolle_id)
            });
        } else {
            retListe.push({
                rolle: rolle,
                items: state.liste.items.filter(x => x.delegation_rolle_id === rolle.rolle_id && !x.ist_abgeschlossen)
            });
        }
    });

    return retListe;
});
export const getListeLaden = createSelector(getPageState, (state: PageState) => state.listeLaden);

export const getGroupedListeVerantwortung = createSelector(getListe, (liste: Array<GroupVerantwortung>) => {
    if (liste === null) {
        return [];
    }

    const fbListe: Array<ListInputItem> = [];
    liste.forEach((groupItem: GroupVerantwortung) => {
        if (groupItem.items !== null && groupItem.items.length > 0) {
            fbListe.push(...groupItem.items.map((item: IncidentKopf) => <ListInputItem>{
                groupId: groupItem.rolle.titel,
                groupTitle: groupItem.rolle.titel,
                itemId: item.incident_id,
                itemTitle: item.titel,
                item: item
            }));
        } else {
            fbListe.push({
                group: groupItem.rolle.titel,
                groupTitle: groupItem.rolle.titel,
                itemId: '',
                itemTitle: '',
                item: null
            });
        }
    });

    return fbListe;
});

export const getListeCount = createSelector(getGroupedListeVerantwortung, (liste: Array<ListInputItem>) => {
    return liste.filter(item => item.item !== null).length;
});

export const getPinnwand = createSelector(getPageState, (state: PageState) => state.pinnwand);
export const getPinnwandLaden = createSelector(getPageState, (state: PageState) => state.pinnwandLaden);

export const getSelectedIncident = createSelector(getPageState, (state: PageState) => state.selectedIncident);

export const getIncidentDetailOriginal = createSelector(getPageState, (state: PageState) => state.incidentDetailOriginal);
export const getIncidentDetail = createSelector(getPageState, (state: PageState) => state.incidentDetail);
export const getIncidentDetailLaden = createSelector(getPageState, (state: PageState) => state.incidentDetailLaden);

export const getIncidentBildIds = createSelector(getPageState, (state: PageState) => state.incidentBildIds);
export const getIncidentBildIdsLaden = createSelector(getPageState, (state: PageState) => state.incidentBildIdsLaden);
export const getIncidentBildIdsFehler = createSelector(getPageState, (state: PageState) => state.incidentBildIdsFehler);

export const getDelegationRollen = createSelector(getIncidentDetail, (detail: IncidentDetail): Array<Rolle> => {
    const retListe: Array<Rolle> = [];

    if (detail !== undefined && detail !== null && detail.ist_verantwortlichkeit_abteilung) {
        detail.abteilungen.forEach(abteilung => {
            if (abteilung.abteilung.funktionsbereich_id === detail.verantwortlichkeit_funktionsbereich_id) {
                retListe.push(...abteilung.rollen);
            }
        });
    }

    if (detail !== undefined && detail !== null && detail.ist_verantwortlichkeit_zentrale) {
        retListe.push(...detail.rollen_zentrale);
    }

    return retListe;
});

export const getPageTitel = createSelector(getFunktionsbereichsId, getIncidentsMandantOptions, getZugriffIncidents,
    (fbId: string, options: IncidentsAnzeigeMandantOptions, zugriffIncidents: IncidentManagementBenutzerZugriff) => {
    let ret: string = 'Abteilungsleitstand' + fbId;
    if (zugriffIncidents !== null && zugriffIncidents.hat_abteilung_leitstand) {
        zugriffIncidents.leitstand_abteilungen.forEach(x => {
            if (fbId === x.funktionsbereich_id) {
                ret = x.bezeichnung;
            }
        });
    }

    return ret;
});

export const getSelectedMeldung = createSelector(getPageState, (state: PageState) => state.selectedMeldung);

export const getLetzteMeldungAnzeigen = createSelector(getPageState, (state: PageState) => state.letzteMeldungenAnzeigen);

export const getLetzteSystemMeldungAnzeigen = createSelector(getPageState, (state: PageState) => state.letzteSystemMeldungenAnzeigen);
